<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-alert variant="success" show dismissible>
          {{ $lang.personal_skills_header }}
          <strong>
            لطفا مهارت‌های خود را به صورت تک تک ثبت نمایید
            <span>از ثبت کلی به صورت متن ممتد بپرهیزید</span>
            حذف یا تغییر مهارت‌ها پس از اعمال دکمه ثبت اتفاق خواهد افتاد
          </strong>
        </b-alert>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.personal_skills"
          label-for="personal_skills"
          :label-cols="$config.form.labelCol"
          class="multiselect-form"
        >
          <requiredComponent
            slot="label"
            :label="$lang.personal_skills"
            :rules="$v.personal_skills_selected.$params"
          />
          <selectFindTags
            :options="personal_skills_options"
            v-model="$v.personal_skills_selected.$model"
            label="text"
            :isValid="
              $v.personal_skills_selected.$dirty
                ? !$v.personal_skills_selected.$error
                : null
            "
            :loading="personal_skills_loading"
            :allowEmpty="true"
            :taggable="true"
            :multiple="true"
            id="value"
            @searchChange="getSkill"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.personal_skills_selected.$error ? 'block' : 'none',
            }"
            id="personal_skills-feedback"
          >
            {{
              $lang.error_required | replace($lang.military_service_status)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col v-if="isAdmin(permissions)" cols="12" class="text-right">
        <b-button variant="success" @click="putSkills">
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { isAdmin } from "@/shared/utils";
import { pathOr } from "ramda";

export default {
  name: "skills-page",
  inject: ["personSkillRepository"],
  validations: {
    personal_skills_selected: {},
  },
  props: {
    code: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      permissions: [],
      personal_skills_options: [],
      personal_skills_loading: false,
      personal_skills_selected: null,
    };
  },
  created() {
    this.getPersonSkill();
  },
  methods: {
    isAdmin,
    pathOr,
    async getSkill(query) {
      if (!query || query.length < 2) {
        this.place_birth_options = [];
        return;
      }
      this.personal_skills_loading = true;
      try {
        const response = await this.personSkillRepository.find(query);
        let skills = response.data.data;
        if (skills.length > 0) {
          this.personal_skills_options = skills.map((x) => {
            return {
              text: x.caption,
              value: x.id,
            };
          });
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.personal_skills_loading = false;
      }
    },
    async getPersonSkill() {
      try {
        this.personal_skills_loading = true;
        const response = await this.personSkillRepository.list(this.code);
        const data = pathOr({}, ["data", "data"], response);
        this.permissions = pathOr([], ["data", "permissions"], response);
        this.$emit("getPermissions", this.permissions);
        this.personal_skills_selected = data.map((x) => {
          return {
            text: x.skill_caption,
            value: x.skill_id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.personal_skills_loading = false;
      }
    },
    async putSkills() {
      try {
        const personal_skills = this.personal_skills_selected.map((x) => {
          if (x.value) {
            return {
              id: x.value,
            };
          } else {
            return {
              caption: x.text,
            };
          }
        });
        const skill = personal_skills || [];
        const payload = { skill };

        const response = await this.personSkillRepository.edit(
          this.code,
          payload
        );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>
